import AAFPlayer from '../../AAFPlayer/AAFPlayer';
import { AAFPLAYER_PLAY } from '../../AAFPlayer/constants';
import settings from '../../devices/all/settings';
import Utils from '../Utils';

class PipManager {
  contructor() {
    this.wasPip = false;
  }

  getWasPip() {
    return this.wasPip;
  }

  closePIP(device, willPause = true) {
    if (device.getDevice().getPlatform() === 'android') {
      //si el PIP esta abierto esta funcion lo cierra

      if (this.wasPip) return;

      let playerState = AAFPlayer.getCurrentPlayingState(false);
      let playerOptions = AAFPlayer.getCurrentPlayerOptions(false);

      if (
        playerState === AAFPLAYER_PLAY &&
        playerOptions &&
        playerOptions.size &&
        playerOptions.size.width &&
        playerOptions.size.width < 1280
      ) {
        /**
         *  OJO: Truco para no detener la reproducción ni alterar el estado del player
         */
        if (willPause) {
          AAFPlayer.pause();
        }
        AAFPlayer.setPlayerSize(false, -1, -1, 1, 1);
        this.wasPip = true;
      }
    }
  }

  resizePIP() {
    let that = this;
    if (that.wasPip) {
      AAFPlayer.setPlayerSize(
        false,
        settings.live_fullplayer_position_top,
        settings.live_fullplayer_position_left,
        settings.live_fullplayer_position_width,
        settings.live_fullplayer_position_height
      );
      that.wasPip = false;
    }
  }
  resizePIPendPlayer() {
    let that = this;
    if (that.wasPip) {
      AAFPlayer.setPlayerSize(
        false,
        settings.end_player_position_top,
        settings.end_player_position_left,
        settings.end_player_position_width,
        settings.end_player_position_height
      );
      that.wasPip = false;
    }
  }
}

export default new PipManager();



// WEBPACK FOOTER //
// ./src/utils/pipManager/PipManager.js